// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yqxzmp0 {
  width: full;
}
.yqxzmp1 {
  max-height: calc(100vh - 180px);
  overflow-y: scroll;
}
@media screen and (min-width: 480px) {
  .yqxzmp0 {
    max-width: 288px;
  }
}
@media screen and (min-width: 768px) {
  .yqxzmp1 {
    max-height: calc(100vh - 300px);
  }
}
@media screen and (max-width: 768px) {
  .yqxzmp2 {
    color: #CC092F;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".yqxzmp0 {\n  width: full;\n}\n.yqxzmp1 {\n  max-height: calc(100vh - 180px);\n  overflow-y: scroll;\n}\n@media screen and (min-width: 480px) {\n  .yqxzmp0 {\n    max-width: 288px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .yqxzmp1 {\n    max-height: calc(100vh - 300px);\n  }\n}\n@media screen and (max-width: 768px) {\n  .yqxzmp2 {\n    color: #CC092F;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
